import { render, staticRenderFns } from "./WlReportsHub.vue?vue&type=template&id=81cb464a"
import script from "./WlReportsHub.vue?vue&type=script&lang=js"
export * from "./WlReportsHub.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports